// extracted by mini-css-extract-plugin
export default {"title":"AlertPopup_title__zko8O","subTitle":"AlertPopup_subTitle__S57Jp","button":"AlertPopup_button__0-6pQ"};